module.exports = __webpack_public_path__ + "static/media/farma-pasa-danima-i-nocima.2e3a2e0a.png";